var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMedicalCenter(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 56,
    height: 56,
    viewBox: "0 0 56 56",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_224",
    "data-name": "Path 224",
    d: "M27,0A27,27,0,1,1,0,27,27,27,0,0,1,27,0Z",
    transform: "translate(1 2)",
    fill: "#eee"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient",
    x2: 0.945,
    y2: 0.956,
    gradientUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#59ac55"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#01a0ea"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "linear-gradient-2",
    x1: -0.538,
    y1: -0.387,
    x2: 0.945,
    y2: 0.956,
    xlinkHref: "#linear-gradient"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1345",
    "data-name": "Group 1345",
    transform: "translate(-1253 -973.875)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Path_67",
    "data-name": "Path 67",
    transform: "translate(1253 973.875)",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M28,0A28,28,0,1,1,0,28,28,28,0,0,1,28,0Z",
    stroke: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 28 1 C 24.35457992553711 1 20.81874084472656 1.713741302490234 17.49068832397461 3.121379852294922 C 14.27566909790039 4.481220245361328 11.38806915283203 6.42816162109375 8.908119201660156 8.908119201660156 C 6.42816162109375 11.38806915283203 4.481220245361328 14.27566909790039 3.121379852294922 17.49068832397461 C 1.713741302490234 20.81874084472656 1 24.35457992553711 1 28 C 1 31.64542007446289 1.713741302490234 35.18125915527344 3.121379852294922 38.50930786132812 C 4.481220245361328 41.72433090209961 6.42816162109375 44.61193084716797 8.908119201660156 47.09188079833984 C 11.38806915283203 49.57183837890625 14.27566909790039 51.51877975463867 17.49068832397461 52.87862014770508 C 20.81874084472656 54.28625869750977 24.35457992553711 55 28 55 C 31.64542007446289 55 35.18125915527344 54.28625869750977 38.50930786132812 52.87862014770508 C 41.72433090209961 51.51877975463867 44.61193084716797 49.57183837890625 47.09188079833984 47.09188079833984 C 49.57183837890625 44.61193084716797 51.51877975463867 41.72433090209961 52.87862014770508 38.50930786132812 C 54.28625869750977 35.18125915527344 55 31.64542007446289 55 28 C 55 24.35457992553711 54.28625869750977 20.81874084472656 52.87862014770508 17.49068832397461 C 51.51877975463867 14.27566909790039 49.57183837890625 11.38806915283203 47.09188079833984 8.908119201660156 C 44.61193084716797 6.42816162109375 41.72433090209961 4.481220245361328 38.50930786132812 3.121379852294922 C 35.18125915527344 1.713741302490234 31.64542007446289 1 28 1 M 28 0 C 43.46397018432617 0 56 12.53602981567383 56 28 C 56 43.46397018432617 43.46397018432617 56 28 56 C 12.53602981567383 56 0 43.46397018432617 0 28 C 0 12.53602981567383 12.53602981567383 0 28 0 Z",
    stroke: "none",
    fill: "#1fa4b6"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Mask_Group_9",
    "data-name": "Mask Group 9",
    transform: "translate(1253 973)",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_1286",
    "data-name": "Group 1286",
    transform: "translate(-14844 22495.945)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "noun-hospital-4398371",
    d: "M72.485,102.382a2.328,2.328,0,0,0-.732-1.685,2.563,2.563,0,0,0-1.767-.7H61.24a2.562,2.562,0,0,0-1.767.7,2.328,2.328,0,0,0-.732,1.685v4.169H52.494v40.5h6.247V136.333H72.485v10.721h6.247v-40.5H72.485ZM59.991,132.759H56.242v-6.552h3.748Zm0-10.125H56.242v-6.552h3.748Zm7.5,10.125H63.739v-6.552h3.748Zm0-10.125H63.739v-6.552h3.748Zm2.5-10.721H61.24a1.282,1.282,0,0,1-.883-.349,1.165,1.165,0,0,1-.366-.842v-8.339a1.165,1.165,0,0,1,.366-.842,1.282,1.282,0,0,1,.883-.349h8.746a1.282,1.282,0,0,1,.883.349,1.165,1.165,0,0,1,.366.842v8.339a1.165,1.165,0,0,1-.366.842A1.282,1.282,0,0,1,69.987,111.912Zm5,20.847H71.236v-6.552h3.748Zm0-16.677v6.552H71.236v-6.552ZM37.5,147.054H51.244v-24.42H37.5Zm8.122-20.847h3.124v6.552H45.622Zm0,10.125h3.124v6.552H45.622Zm-4.373-10.125h3.124v6.552H41.248Zm0,10.125h3.124v6.552H41.248Zm38.734-13.7v24.42H93.727v-24.42Zm5.623,20.251H82.481v-6.552h3.124Zm0-10.125H82.481v-6.552h3.124Zm4.373,10.125H86.854v-6.552h3.124Zm0-10.125H86.854v-6.552h3.124Zm-24.99,4.765h1.249v9.53H64.989Z",
    transform: "translate(14805.773 -22588)",
    stroke: "rgba(0,0,0,0)",
    strokeWidth: 1,
    fill: "url(#linear-gradient)"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_1284",
    "data-name": "Group 1284",
    transform: "translate(14866.386 -22485.488)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path",
    d: "M4.017,4.266C3.323,4.788,1.971,4.179.869,3A4.018,4.018,0,0,1,.027,0,5.194,5.194,0,0,1,3.175,1.265c1.1,1.178,1.537,2.478.842,3",
    transform: "translate(1.638 1.114)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-2",
    "data-name": "Path",
    d: "M1.505,5.569c.906,0,1.505-1.247,1.505-2.784A4.265,4.265,0,0,0,1.505,0,4.265,4.265,0,0,0,0,2.784C0,4.322.6,5.569,1.505,5.569",
    transform: "translate(3.645 0)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-3",
    "data-name": "Path",
    d: "M.335,4.266C1.029,4.788,2.381,4.179,3.483,3a4.018,4.018,0,0,0,.842-3A5.193,5.193,0,0,0,1.178,1.265c-1.1,1.178-1.537,2.478-.843,3",
    transform: "translate(4.309 1.114)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-4",
    "data-name": "Path",
    d: "M0,1.086A2.781,2.781,0,0,1,.237,0a3.349,3.349,0,0,1,.932.682c1.1,1.178,1.537,2.478.842,3a.978.978,0,0,1-.551.186C.579,3.828,0,2.6,0,1.086",
    transform: "translate(3.645 1.698)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-5",
    "data-name": "Path",
    d: "M2.346,1.086A2.785,2.785,0,0,0,2.109,0a3.353,3.353,0,0,0-.932.682c-1.1,1.178-1.537,2.478-.842,3a.979.979,0,0,0,.551.186c.881-.041,1.46-1.27,1.46-2.782",
    transform: "translate(4.309 1.698)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-6",
    "data-name": "Path",
    d: "M.839,3.991l-.631-1.5C-.237,1.977.058.981.839,0c.781.981,1.076,1.977.631,2.491Z",
    transform: "translate(4.311 2.77)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-7",
    "data-name": "Path",
    d: "M0,3.391A3.309,3.309,0,0,1,1.765.737,4.1,4.1,0,0,1,5.149.158a6.925,6.925,0,0,0-2.985,1.09A6.081,6.081,0,0,0,0,3.391",
    transform: "translate(5.151 3.426)",
    fill: "url(#linear-gradient-2)"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path-8",
    "data-name": "Path",
    d: "M5.148,3.391A3.31,3.31,0,0,0,3.384.737,4.1,4.1,0,0,0,0,.158a6.926,6.926,0,0,1,2.985,1.09A6.082,6.082,0,0,1,5.148,3.391",
    transform: "translate(0 3.426)",
    fill: "url(#linear-gradient-2)"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMedicalCenter);
export default __webpack_public_path__ + "static/media/medicalCenter.f9cf616c12d20695c4fca815fc54a6a3.svg";
export { ForwardRef as ReactComponent };